import { supabaseClient } from "@/lib/supabase";

import type { OwnOptionT } from "../ownOptions";

/** Adds a private choice of the signed-in respondent's own to a question that allows it (add_own_option). */
export async function insertOwnOption(inputId: string, label: string): Promise<OwnOptionT> {
    const { data } = await supabaseClient
        .rpc("add_own_option", { p_input_id: inputId, p_label: label })
        .single()
        .throwOnError();
    return { option_id: data.option_id, input_id: inputId, label: data.label };
}

/**
 * Deletes one of the signed-in respondent's own options (delete_own_option). Refused while an answer in another
 * entry uses it; an answer in `entryId`, the entry being filled in, doesn't block it.
 */
export async function deleteOwnOption(optionId: string, entryId: string): Promise<void> {
    await supabaseClient.rpc("delete_own_option", { p_option_id: optionId, p_entry_id: entryId }).throwOnError();
}

/** Renames one of the signed-in respondent's own options (rename_own_option). */
export async function updateOwnOption(optionId: string, label: string): Promise<OwnOptionT> {
    const { data } = await supabaseClient
        .rpc("rename_own_option", { p_option_id: optionId, p_label: label })
        .single()
        .throwOnError();
    return { option_id: data.option_id, input_id: data.input_id ?? "", label: data.label };
}
